import {useState} from "react";

const LINE = '#ca8a04';

/**
 * Biểu đồ vị trí SERP theo ngày cho MỘT từ khoá (SVG thuần, không lib). Trục Y ĐẢO: hạng tốt
 * (số nhỏ) ở TRÊN. Chỉ vẽ ngày có vị trí (lọt top 100). series: [{date, position, url}].
 */
function RankChart({series = []}) {

	const [hover, setHover] = useState(null);

	const pts = series.filter((d) => Number(d.position) > 0);

	if (pts.length === 0) {
		return <div style={{color: '#9ca3af', padding: '24px 0', textAlign: 'center'}}>Chưa có dữ liệu vị trí (từ khoá chưa lọt top 100 hoặc chưa kiểm tra).</div>;
	}

	const W = 720, H = 220, P = 30;
	const innerW = W - P * 2, innerH = H - P * 2;
	const n = pts.length;

	const positions = pts.map((d) => Number(d.position));
	let minPos = Math.min(...positions);
	let maxPos = Math.max(...positions);
	if (maxPos === minPos) { maxPos += 1; minPos = Math.max(1, minPos - 1); }

	const x = (i) => (n === 1 ? W / 2 : P + (innerW * i) / (n - 1));
	const y = (pos) => P + (innerH * (pos - minPos)) / (maxPos - minPos);

	const linePts = pts.map((d, i) => ({x: x(i), y: y(Number(d.position))}));
	const line = 'M ' + linePts.map((p) => `${p.x},${p.y}`).join(' L ');
	const ticks = n === 1 ? [0] : [0, Math.floor((n - 1) / 2), n - 1];
	const last = n - 1;

	const handleMove = (e) => {
		const rect = e.currentTarget.getBoundingClientRect();
		const frac = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
		setHover(n === 1 ? 0 : Math.round(frac * (n - 1)));
	};

	const hoverPct = hover === null ? 0 : (n === 1 ? 50 : (hover / (n - 1)) * 100);

	return (
		<div style={{position: 'relative'}}>
			<div style={{fontSize: 12, color: '#6b7280', marginBottom: 6}}>
				<span style={{display: 'inline-block', width: 10, height: 10, borderRadius: '50%', background: LINE, marginRight: 6}} />
				Vị trí trên Google (nhỏ hơn = tốt hơn)
			</div>
			<div style={{position: 'relative'}} onMouseMove={handleMove} onMouseLeave={() => setHover(null)}>
				<svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" style={{width: '100%', height: 'auto'}}>
					{[0, 0.5, 1].map((g) => (
						<line key={g} x1={P} y1={P + innerH * g} x2={W - P} y2={P + innerH * g}
							stroke="#eef0f4" strokeWidth="1" vectorEffect="non-scaling-stroke" />
					))}
					<text x={4} y={P + 4} fontSize="10" fill="#9ca3af">#{Math.round(minPos)}</text>
					<text x={4} y={P + innerH} fontSize="10" fill="#9ca3af">#{Math.round(maxPos)}</text>

					{n > 1 && (
						<path d={line} fill="none" stroke={LINE} strokeWidth="2.5"
							strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
					)}

					{linePts.map((p, i) => (
						<circle key={i} cx={p.x} cy={p.y} r={hover === i ? 4.5 : (i === last ? 3.5 : 2.5)}
							fill="#fff" stroke={LINE} strokeWidth="2" vectorEffect="non-scaling-stroke" />
					))}

					{hover !== null && (
						<line x1={x(hover)} y1={P} x2={x(hover)} y2={P + innerH}
							stroke="#94a3b8" strokeWidth="1" strokeDasharray="4 3" vectorEffect="non-scaling-stroke" />
					)}

					{ticks.map((i) => (
						<text key={i} x={x(i)} y={H - 6} fontSize="10" fill="#9ca3af"
							textAnchor={i === 0 ? 'start' : i === n - 1 ? 'end' : 'middle'}>
							{String(pts[i].date).slice(5)}
						</text>
					))}
				</svg>

				{hover !== null && (
					<div style={{position: 'absolute', top: 0, transform: 'translateX(-50%)', left: `${hoverPct}%`,
						background: '#111827', color: '#fff', fontSize: 12, padding: '6px 10px', borderRadius: 6, pointerEvents: 'none', whiteSpace: 'nowrap'}}>
						<div style={{opacity: 0.7}}>{pts[hover].date}</div>
						<div>Vị trí <b>#{pts[hover].position}</b></div>
					</div>
				)}
			</div>
		</div>
	);
}

export default RankChart;
